import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const PageLoadingState = ({
  message,
  rows = 8,
  className = ''
}) => {
  const { t } = useTranslation()
  const shownMessage = message ?? t('common.loading')
  return (
    <div
      role='status'
      aria-live='polite'
      className={`min-h-[420px] border border-gray-200 rounded-xl bg-gray-50 p-6 flex flex-col gap-6 ${className}`}
    >
      <div>
        <div className='h-5 w-48 rounded bg-gray-200 animate-pulse mb-3' />
        <div className='h-4 w-72 max-w-full rounded bg-gray-200 animate-pulse' />
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6'>
        {Array.from({ length: rows }).map((_, index) => (
          <div key={index} className='space-y-2'>
            <div className='h-4 w-24 rounded bg-gray-200 animate-pulse' />
            <div className='h-10 w-full rounded-md bg-gray-200 animate-pulse' />
          </div>
        ))}
      </div>
      <span className='sr-only'>{shownMessage}</span>
    </div>
  )
}

PageLoadingState.propTypes = {
  message: PropTypes.string,
  rows: PropTypes.number,
  className: PropTypes.string
}

export default PageLoadingState
